import { Box } from '@mui/material';
import { runRx } from '../../lib/api.js';
import { FullScreenDialog } from '../../components/FullScreenDialog';
import { useAlerts } from '../../hooks/use-alerts.js';
import { useGrowers } from '../../hooks/use-growers.js';
import { useContext } from './context.jsx';
import { SidePanel } from './SidePanel.jsx';
import { Modules } from './Modules.jsx';

export function RunRxDialog() {
  const { close, isOpen, isValid, setErrors, getParams } = useContext();
  const { selectedId: growerId } = useGrowers();
  const { showError } = useAlerts();

  if (!isOpen) return null;

  return (
    <FullScreenDialog
      actions
      saveLabel="Run Rx"
      canSave={isValid}
      onSave={run}
      onCancel={close}
    >
      <Box sx={{ height: '100%', overflow: 'hidden', display: 'flex' }}>
        <SidePanel />
        <Modules />
      </Box>
    </FullScreenDialog>
  );

  function run() {
    showError(null);
    setErrors([]);

    return runRx(growerId, getParams())
      .then(close)
      .catch((e) => {
        if (e.status !== 400) throw e;
        showError('Please fix the errors below');
        setErrors(e.response?.data || []);
      });
  }
}
